module.exports = __webpack_public_path__ + "front/img/sub-img-3.7dc85d9a.png";